import { ConversationApi, FlowApi,MessagesApi,TargetingApi } from 'api'
import { AxiosPromise } from 'axios'
import { ApiResult } from 'types/api'
import { CampaignInteractionRecord, PrerenderedBotCampaign } from 'types/campaigns'
import { GeoLocation } from 'types/geoip'

interface GetPersonalizedAnnouncementMessageArgs {
  campaignId: number,
  senderId: number,
  endUserId: number
}


interface ClientSideContext {
  embedId: string,
  pageUrl?: string,
  sessionId?: string,
  siteVisits?: number,
  location?: GeoLocation | {}
}
interface GetInitialBotMessageArgs {
  playbookId: number,
  interactionId?: number,
  campaignId: number,
  inboxId: number,
  locale: string,
  clientSideContext: ClientSideContext
}

export const getInitialBotMessagesForPlaybook = (payload: GetInitialBotMessageArgs): AxiosPromise<PrerenderedBotCampaign> => {
  return FlowApi.post('/flows/render_initial_v3', payload)
}

export const enrollCampaign = (id: number, senderId: number, campaignRefreshToken: string, originWidgetLocale: string) =>
  ConversationApi.post<ApiResult>(`campaigns/${id}/enroll`, {
    senderId,
    sessionId: campaignRefreshToken,
    originWidgetLocale
  })

export const getPersonalizedAnnouncementMessage = ({
  campaignId,
  senderId,
  endUserId
}: GetPersonalizedAnnouncementMessageArgs) => {
  return ConversationApi.post(`personalization/announcement`, {
    campaignId,
    senderId,
    endUserId
  })
}

export const persistCampaignInteractionEvent = (payload: CampaignInteractionRecord) => {
  return TargetingApi.post(`campaigns/interactions`, payload)
}

export const createAnnouncementCampaignConversation = (payload) => {
  return MessagesApi.post('announcement_campaigns', payload)
}
